// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/** Palette identifiers. `source` is the dataset's own ramp — the
 *  default, and the only one the publisher chose. AYNI: the AYNI 2D set
 *  (inferno, plasma, cividis, cool–warm added); a reversed ramp is the
 *  `inverted` flag, not a second list of ids. Kept apart from
 *  `colorScaleDisplay.ts`, which re-exports them, so Pages Functions can
 *  import them alone. */
export const PALETTE_IDS = ['source', 'viridis', 'magma', 'inferno', 'plasma', 'cividis', 'turbo', 'coolwarm', 'grayscale'] as const

export type PaletteId = (typeof PALETTE_IDS)[number]
